import _defineProperty from "/home/moongchigo/www/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _classCallCheck from "/home/moongchigo/www/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/moongchigo/www/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/moongchigo/www/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/moongchigo/www/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/moongchigo/www/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import Icon from '../Icon/Icon';
import style from './Button.module.css';

var Button = /*#__PURE__*/function (_Component) {
  _inherits(Button, _Component);

  var _super = _createSuper(Button);

  function Button() {
    _classCallCheck(this, Button);

    return _super.apply(this, arguments);
  }

  _createClass(Button, [{
    key: "render",
    value: function render() {
      // Pass native attr
      var conditionalAttr = {};

      if (this.props.disabled) {
        conditionalAttr.disabled = true;
      } // Set custom kakao icon and icon size


      var iconType = '';
      var iconSize = 0;

      if (this.props.kakao && this.props.outline) {
        iconType = 'kakao';
        iconSize = 20;
      } else if (this.props.kakao) {
        iconType = 'kakao_channel';
        iconSize = 34;
      } else {
        iconType = this.props.icon;
        iconSize = 18;
      } // Set css class 
      // mix template litterale and old school concatination to fix source view empty space issue ( TODO : find a better way)


      var cssClass = "".concat(style.container) + "".concat(iconType ? ' ' + style.has_icon : '') + "".concat(this.props.outline ? ' ' + style.outline : '') + "".concat(this.props.secondary ? ' ' + style.secondary : '') + "".concat(this.props.seamless ? ' ' + style.seamless : '') + "".concat(this.props.inline ? ' ' + style.inline : '') + "".concat(this.props.size === 'medium' ? ' ' + style.medium : '') + "".concat(this.props.size === 'mini' ? ' ' + style.mini : '') + "".concat(this.props.kakao ? ' ' + style.kakao : '') + "".concat(this.props.more ? ' ' + style.more : ''); // Create icon compoment wrapper

      var icon = /*#__PURE__*/_jsx("span", {
        className: "".concat(style.icon, " ").concat(this.props.iconRight ? style.icon_right : ''),
        children: /*#__PURE__*/_jsx(Icon, {
          type: iconType,
          size: this.props.iconSize ? this.props.iconSize : iconSize
        })
      }); // Render the markup


      return /*#__PURE__*/_jsx("button", _objectSpread(_objectSpread({}, conditionalAttr), {}, {
        className: cssClass,
        onClick: typeof this.props.onClick === 'function' ? this.props.onClick : null,
        children: /*#__PURE__*/_jsxs("span", {
          className: style.inner,
          children: [iconType && !this.props.iconRight && icon, /*#__PURE__*/_jsx("span", {
            className: style.text,
            children: this.props.children
          }), iconType && this.props.iconRight && icon]
        })
      }));
    }
  }]);

  return Button;
}(Component);

export { Button as default };